<span
  [matMenuTriggerFor]="menu"
  cdkOverlayOrigin
  #menuTrigger="matMenuTrigger"
  (mouseenter)="menuTrigger.openMenu()"
  (mouseleave)="menuTrigger.closeMenu()"
  class="
    lum-chip lum-chip--label lum-chip--small border-color-white font-bold border-transparent
  "
  [ngClass]="classes"
  >{{ status }}</span
>
<mat-menu
  class="lum-popover invoice-skus-status__popover"
  #menu="matMenu"
  [overlapTrigger]="false"
  xPosition="after"
  hasBackdrop="false"
>
  <div class="stock flex gap-4">
    <div class="stock__item">
      <div class="text-center">
        <b>Incoming</b>
        {{ item?.location_stock?.qty_incoming ?? 0 | number }}
      </div>
    </div>
    <div class="stock__item">
      <div class="text-center">
        <b>On-hand</b>
        {{ item?.location_stock?.qty_onhand ?? 0 | number }}
      </div>
    </div>
    <div class="stock__item">
      <div class="text-center">
        <b>Available</b>
        {{
          item?.location_stock?.qty_onhand - item?.location_stock?.qty_pending ?? 0
            | number
        }}
      </div>
    </div>
  </div>
</mat-menu>
